// extracted by mini-css-extract-plugin
export default {"wonButton":"useActions_wonButton__T+kR9","lostButton":"useActions_lostButton__X370j","reOpenButton":"useActions_reOpenButton__Fd7e1"};